(function($, WG) {
    function main() {
        WG.init();
    }
    $(main);
})($, window.WG);



// WEBPACK FOOTER //
// ./assets/js/common/modules/init-wg.js